module.exports = __webpack_public_path__ + "img/user22.c49a9a06.jpg";